import { endOfDay, formatISO, parseISO, subDays } from "date-fns";
import { fromZonedTime, toZonedTime } from "date-fns-tz";
import { OrderType } from "../../order/constants.js";
import { resolveSkipBookDeadline } from "../../subscription-product/utils/resolveSkipBookDeadline.js";
const TIME_ZONE = "Europe/Oslo";
/**
 * Adjusts a deadline to a valid skip book deadline.
 * Book subscription: Keeps an explicit time of day, date-only deadlines expire
 * at 23:59:59.999 Norwegian time.
 * Series subscription: Moves one day earlier and expires at 23:59:59.999
 * Norwegian time, since the renewal date carries no meaningful time of day.
 *
 * @param {string | undefined} deadline ISO date string (renewal date for series, cancellation deadline from distribution table for book)
 * @param {OrderType} type Order type
 * @returns {string | undefined} Adjusted deadline in ISO format
 */
export function getSkipBookDeadline(deadline, type) {
    if (!deadline)
        return undefined;
    if (type === OrderType.SERIES_SUBSCRIPTION) {
        const previousDay = subDays(parseISO(deadline), 1);
        const endOfPreviousDay = endOfDay(toZonedTime(previousDay, TIME_ZONE));
        return formatISO(fromZonedTime(endOfPreviousDay, TIME_ZONE));
    }
    return formatISO(resolveSkipBookDeadline(deadline));
}
